import * as React from "react";
import { IconProps } from "./IconProps";

export const IconDestructive = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g id="Group">
          <path
            id="Vector"
            d="M11.5595 10.0001L6.88598 1.07507C6.62948 0.586066 6.02548 0.397066 5.53598 0.653566C5.35598 0.748066 5.20898 0.895066 5.11448 1.07507L0.440478 10.0001C0.183978 10.4891 0.372978 11.0936 0.862478 11.3501C1.00548 11.4251 1.16498 11.4641 1.32648 11.4641H10.6735C11.226 11.4641 11.6735 11.0166 11.6735 10.4641C11.6735 10.3026 11.6345 10.1431 11.5595 10.0001ZM5.49998 4.21157C5.49998 3.93557 5.72398 3.71157 5.99998 3.71157C6.27598 3.71157 6.49998 3.93557 6.49998 4.21157V7.21157C6.49998 7.48757 6.27598 7.71157 5.99998 7.71157C5.72398 7.71157 5.49998 7.48757 5.49998 7.21157V4.21157ZM6.02498 9.96657H6.01098C5.60148 9.96507 5.26548 9.64107 5.24998 9.23157C5.23498 8.82407 5.55298 8.48207 5.96048 8.46707C5.96498 8.46707 5.96948 8.46657 5.97398 8.46657H5.98798C6.39748 8.46707 6.73398 8.79057 6.74998 9.20007C6.76598 9.60707 6.44898 9.95007 6.04198 9.96607C6.03648 9.96607 6.03048 9.96657 6.02498 9.96657Z"
            fill={color}
          />
        </g>
      </svg>
    );
  },
);
